import reportAndEditInventorySagas from './reportAndEditInventory'
import fetchInfoNeededToConstructDistributorReportInventoryNoLoginRequiredFormSagas from './fetchInfoNeededToConstructDistributorReportInventoryNoLoginRequiredForm'

// CODE_COMMENTS_11
export default [
  ...reportAndEditInventorySagas,
  ...fetchInfoNeededToConstructDistributorReportInventoryNoLoginRequiredFormSagas,
]
